import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=e55a6300&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=e55a6300&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55a6300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55a6300')) {
      api.createRecord('e55a6300', component.options)
    } else {
      api.reload('e55a6300', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=e55a6300&scoped=true", function () {
      api.rerender('e55a6300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/wedding/goods.vue"
export default component.exports